import { Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Radio } from '@components/core-ui/form-elements/Radio';
import { ModalFooterEnd } from '@modals/core-ui/ModalFooter/variations/ModalFooterEnd';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { Tooltip } from '@components/core-ui/Tooltip';
import { useAuthContext } from '@providers/AuthProvider';
import { useState } from 'react';

import { Content } from './styles/Content';
import { TProps } from './types/TProps';

export const AddWSToTeamModal = ({ workspaceIds, onCancel, onSuccess }: TProps) => {
  const { organization } = useAuthContext();
  const [selectedWorkspaceSlug, setSelectedWorkspaceSlug] = useState('');

  return (
    <ModalWrapper width="487px">
      <ModalTitle>Attach Workspace to Team</ModalTitle>
      <Content>
        <TableWrapper className="customTable">
          <Table>
            <Thead $white>
              <Tr>
                <Th>Workspace Name</Th>
              </Tr>
            </Thead>
            <Tbody>
              {organization?.workspaces?.map((data) => {
                const disabled = workspaceIds.includes(data.id);
                const disabledInfo = 'Cannot add already existent Workspace';
                return (
                  <Tr key={data.id}>
                    <Td>
                      {disabled ? (
                        <Tooltip content={disabledInfo} placement="bottom">
                          <div className="radioWrapper disabled">
                            <Radio onChange={() => {}} checked={selectedWorkspaceSlug === data.slug} disabled={true}>
                              {data?.name}
                            </Radio>
                          </div>
                        </Tooltip>
                      ) : (
                        <div className="radioWrapper">
                          <Radio
                            onChange={() => setSelectedWorkspaceSlug(data.slug)}
                            checked={selectedWorkspaceSlug === data.slug}
                          >
                            {data?.name}
                          </Radio>
                        </div>
                      )}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableWrapper>
        <ModalFooterEnd>
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button disabled={!selectedWorkspaceSlug} onClick={() => onSuccess(selectedWorkspaceSlug)}>
            Attach
          </Button>
        </ModalFooterEnd>
      </Content>
    </ModalWrapper>
  );
};
